interface TableState {
  isGenerating: boolean;
  isQueryLoading: boolean;
  progressMessages: string[];
  tableData: { columns: Column[]; rows: Row[] } | null;
  error: string | null;
  queryResponse: string | null;
  indexFiles: FileInfo[];
  userIndexes: IndexInfo[];
  tableType: string | null;
  suggestedQueries: string[];
}

interface Column {
  id: string;
  name: string;
}

interface Row {
  file_id: string;
  file_name: string;
  [key: string]: string;
}

interface FileInfo {
  file_id: string;
  file_name: string;
  blob_url: string;
}

interface IndexInfo {
  index_name: string;
  table_name: string;
  file_count: number;
  created_at: string;
}

const initialState: TableState = {
  isGenerating: false,
  isQueryLoading: false,
  progressMessages: [],
  tableData: null,
  error: null,
  queryResponse: null,
  indexFiles: [],
  userIndexes: [],
  tableType: null,
  suggestedQueries: []
};

export default function tablesReducer(state = initialState, action: any): TableState {
  switch (action.type) {
    case 'GENERATE_TABLE_START':
      return { ...state, isGenerating: true, error: null, progressMessages: [], tableData: null, tableType: null, suggestedQueries: [] };
    case 'UPDATE_PROGRESS':
      return { ...state, progressMessages: [...state.progressMessages, action.payload] };
    case 'SET_TABLE_DATA':
      return {
        ...state,
        isGenerating: false,
        tableData: action.payload.table_data,
        tableType: action.payload.table_type,
        suggestedQueries: action.payload.suggested_queries
      };
    case 'SET_ERROR':
      return { ...state, isGenerating: false, isQueryLoading: false, error: action.payload };
    case 'RUN_QUERY_SUCCESS':
      return { ...state, queryResponse: action.payload };
    case 'SET_INDEX_FILES':
      return { ...state, indexFiles: action.payload };
    case 'SET_USER_INDEXES':
      return { ...state, userIndexes: action.payload };
    case 'SET_QUERY_LOADING':
      return { ...state, isQueryLoading: action.payload };
    default:
      return state;
  }
}